/**
 * Module dependencies.
 */

import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { AxiosInstance } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { useGetNotesFileSystemInvalidator } from './use-get-notes-file-system';

/**
 * `Payload` type.
 */

type Payload = {
  id: string;
};

/**
 * Post delete item.
 */

async function postDeleteItem(client: AxiosInstance, id: string): Promise<void> {
  return await client({
    method: 'delete',
    url: resolveAppUrl('appsNotesById', { interpolations: { id } })
  });
}

/**
 * Export `useDeleteItem`.
 */

export function useDeleteItem() {
  const client = useRequestProvider();
  const invalidator = useGetNotesFileSystemInvalidator();

  return useMutation({
    mutationFn: async ({ id }: Payload) => {
      const result = await postDeleteItem(client, id);

      await invalidator();

      return result;
    }
  });
}
